export class ReplyInformation {
  public message: string;
}
